import React, { useState } from "react";
import TextField from "@mui/material/TextField";

const SearchInput = ({ updateSearchValue }) => {
  const [query, setQuery] = useState("");

  const handleInputChange = (event) => {
    const value = event.target.value;
    setQuery(value);
    updateSearchValue(value);
  };

  return (
    <TextField
      value={query}
      onChange={handleInputChange}
      placeholder="Search by driver's code, name, phone no or email"
      variant="outlined"
      size="small"
      sx={{
        width: 500,
        "& .MuiOutlinedInput-root": {
          borderRadius: 1,
        },
      }}
    />
  );
};

export default SearchInput;